import { MasterButton } from "App/Component/ui";
import { instance4 } from "App/constants";
import {
  defaultDateInputDisplay,
  isNull,
  oneMonthBeforeToday,
} from "App/utils/helpers";
import moment from "moment";
import {
  STATUS_PENGERJAAN_DRAFT,
  STATUS_PENGERJAAN_DISETUJUI,
  STATUS_PENGERJAAN_PENGAJUAN,
  STATUS_PENGERJAAN_REVISI,
  STATUS_PENGERJAAN_REJECT,
  STATUS_PENGERJAAN_PENDING,
  STATUS_PENGERJAAN_PROSES,
  STATUS_PENGERJAAN_SELESAI,
} from "../HelpDesk/helpers";
import React from "react";
import { lastOfDay, startOfDay } from "utils/dates";

export const urlGet = "/wmsAsset/helpdesk/list";
export const urlDelete = "/wmsAsset/helpdesk/delete-header";
export const urlGetBarangReqById = "/wmsAsset/helpdesk/list-detail-id";

export const RESET_STATE_FORM_FILTER = {
  pages: 1,
  limit: 10,
  id: "",
  nama_request: "",
  unit_id: null,
  unit: "Pilih Unit",
  gudang_id: null,
  gudang: "Pilih Unit",
  status_request: null,
  nama_status_request: "Pilih Status",
  tglAwal: oneMonthBeforeToday(),
  tglAkhir: moment(new Date()).local().toDate(),
};

export const getByFilter = async (
  formFilter,
  pages,
  limit,
  alwaysPengadaan = false
) => {
  try {
    const api = await instance4.post(urlGet, {
      halaman: pages,
      jumlah: limit,
      id: formFilter?.id,
      unit_id: formFilter?.unit_id,
      gudang_id: formFilter?.gudang_id,
      status_verifikasi: alwaysPengadaan ? 1 : formFilter?.status_request,
      tglAwal: isNull(formFilter.tglAwal)
        ? ""
        : startOfDay(formFilter.tglAwal),
      tglAkhir: isNull(formFilter.tglAkhir)
        ? ""
        : lastOfDay(formFilter.tglAkhir),
    });

    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.body,
        meta: {
          count: parseInt(res.count),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      };
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const deleteById = async (id) => {
  try {
    const api = await instance4.post(urlDelete, { id }, {});
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        message: "Berhasil menghapus Request",
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      data: {},
      message: error?.response?.data?.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
    minWidth: "80px",
  },
  {
    id: "unit",
    disablePadding: false,
    label: "UNIT",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "gudang",
    disablePadding: false,
    label: "GUDANG",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "user_request",
    disablePadding: false,
    label: "USERNAME REQUEST",
    align: "left",
    minWidth: "170px",
  },
  {
    id: "status_verifikasi",
    disablePadding: false,
    label: "STATUS VERIFIKASI",
    align: "left",
    minWidth: "180px",
  },
  {
    id: "remark",
    disablePadding: false,
    label: "CATATAN",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "tanggal_verifikasi",
    disablePadding: false,
    label: "TGL VERIFIKASI",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "user_verifikasi",
    disablePadding: false,
    label: "USER VERIFIKASI",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "remak_verifikasi",
    disablePadding: false,
    label: "CATATAN VERIFIKASI",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "tgl_permintaan",
    disablePadding: false,
    label: "TGL PERMINTAAN",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "createdAt",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "createdBy",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updatedAt",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updatedBy",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const RenderStatusVerifikasiBadge = ({ status }) => {
  if (status === STATUS_PENGERJAAN_DRAFT) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"DRAFT"}
        color={"secondary"}
        type="button"
        disabled
      />
    );
  } else if (status === STATUS_PENGERJAAN_PENGAJUAN) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"PENGAJUAN"}
        color={"warning"}
        type="button"
        disabled
      />
    );
  } else if (status === STATUS_PENGERJAAN_DISETUJUI) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"DISETUJUI"}
        color={"lightgreen"}
        type="button"
        disabled
      />
    );
  } else if (status === STATUS_PENGERJAAN_PENDING) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"PENDING"}
        color={"warning"}
        type="button"
        disabled
      />
    );
  } else if (status === STATUS_PENGERJAAN_PROSES) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"PROSES"}
        color={"green"}
        type="button"
        disabled
      />
    );
  } else if (status === STATUS_PENGERJAAN_SELESAI) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"SELESAI"}
        color={"green"}
        type="button"
        disabled
      />
    );
  } else if (status === STATUS_PENGERJAAN_REVISI) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"REVISI"}
        color={"warning"}
        type="button"
        disabled
      />
    );
  } else if (status === STATUS_PENGERJAAN_REJECT) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"DITOLAK"}
        color={"danger"}
        type="button"
        disabled
      />
    );
  } else {
    return <p>-</p>;
  }
};


export const getNotifReqFA = async ({ id }) => {
  const api = await getByFilter({ id_request: id }, 1, 1);
  if (api.state) {
    const rowsData = api.data[0];
    const dataProps = {
      idreq: rowsData?.id,
      nama: rowsData?.name,
      unit_id: rowsData?.unit_id,
      unit: rowsData?.unit,
      status_kebutuhan: rowsData?.status_kebutuhan,
      status_kebutuhan_nama:
        rowsData?.status_kebutuhan === 1
          ? "Normal"
          : rowsData?.status_kebutuhan === 2
          ? "Medium"
          : rowsData?.status_kebutuhan === 3
          ? "Urgent"
          : "Tidak Ditemukan",
      remark: rowsData?.remark,
      remak_verifikasi: rowsData?.remak_verifikasi,
      status_verifikasi: rowsData?.status_verifikasi,
      user_request: rowsData?.user_request,
      type: "update",
      status: true,
      isOpenDraf:
        rowsData?.status_verifikasi === STATUS_PENGERJAAN_DRAFT
          ? true
          : rowsData?.status_verifikasi === STATUS_PENGERJAAN_REVISI
          ? true
          : false,
      isProcess:
        rowsData?.status_verifikasi === STATUS_PENGERJAAN_DRAFT
          ? false
          : rowsData?.status_verifikasi === STATUS_PENGERJAAN_REVISI
          ? false
          : true,
      date: defaultDateInputDisplay(rowsData?.tgl_permintaan),
      listreq: [],
    };
    return dataProps;
  } else {
    return null;
  }
};

export const getReqListById = async (id) => {
  try {

    const api = await instance4.get(`${urlGetBarangReqById}/${id}`);
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.body,
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};